import { createAsyncThunk } from "@reduxjs/toolkit";
import { accountSettingsAPI } from "../api";
import { authActions } from "../../auth/redux/slice";
import {
  handleErrors,
  type ApiError,
  type GetThunkAPI,
} from "../../../api/errorUtils";
import type {
  BackendResponseDetail,
  CreatePetRequest,
  CreatePetResponse,
  PatchUserProfile,
  // ProfileInterface,
  ChangePasswordFormValues,
  UpdatePetRequest,
  UserProfileInterface,
  WalletBalance,
  WithdrawRequest,
  AboutMePatchRequest,
  PresignUploadResponse,
  PresignUrlRequest,
  AboutMePatchResponse,
  DeletePetResponse,
  DeletePetRequest,
  UpdatePetResponse,
  GetPetByIdResponse,
  GetPetByIdRequest,
  ContactPreferenceRequest,
  ContactPreferenceResponse,
  SendOtpRequest,
  SendOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
  UpdateNotificationPreferenceRequest,
  SearchAddress,
} from "../ts";
import { serializePresignUrlPyalod } from "../utils/serializers";
import type {
  CreateProfileAddressRequest,
  CreateProfileAddressResponse,
} from "../../common/ts";

export const GetUserProfileThunk = createAsyncThunk<UserProfileInterface>(
  "accountSettingsSlice/get_user_profile_thunk",
  async (_, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.getUserProfile();
      thunkAPI.dispatch(
        authActions.setAuthUser({
          id: data.id,
          user_id: data.user,
          email: data.email,
        }),
      );
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const GetFullUserProfileThunk = createAsyncThunk<UserProfileInterface>(
  "accountSettingsSlice/get_full_user_profile_thunk",
  async (_, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.getFullUserProfile();
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const ChangePasswordThunk = createAsyncThunk<
  BackendResponseDetail,
  ChangePasswordFormValues
>(
  "accountSettingsSlice/change_password_thunk",
  async (requestData, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.changePassword(requestData);
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const PatchSitterProfile = createAsyncThunk<void, PatchUserProfile>(
  "accountSettingsSlice/patch_sitter_profile_thunk",
  async (requestData, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.patchSitterProfile(requestData);
      thunkAPI.dispatch(GetFullUserProfileThunk());
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const UpdateAboutMeThunk = createAsyncThunk<
  AboutMePatchResponse,
  AboutMePatchRequest
>(
  "accountSettingsSlice/patch_about_me_thunk",
  async (requestData, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.updateAboutMeThunk(requestData);
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const GetWalletBalanceThunk = createAsyncThunk<WalletBalance>(
  "accountSettingsSlice/get_wallet_balance_thunk",
  async (_, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.getWalletBalance();
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const CreateWithdrawThunk = createAsyncThunk<
  BackendResponseDetail,
  WithdrawRequest
>("accountSettingsSlice/withdraw_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await accountSettingsAPI.withdraw(requestData);
    return data;
  } catch (err: unknown) {
    return handleErrors(err as ApiError, thunkAPI);
  }
});

export const CreateDocPresignUrlForPetThunk = createAsyncThunk<
  PresignUploadResponse,
  PresignUrlRequest
>("conversations/create_presign_upload", async (requestData, thunkAPI) => {
  try {
    const serializedFormData = await serializePresignUrlPyalod(requestData);
    const response = await accountSettingsAPI.createDocPresignUrlForPet(
      requestData.id as string,
      serializedFormData,
    );

    return response.data;
  } catch (err: unknown) {
    return handleErrors(err as ApiError, thunkAPI);
  }
});

export const CreateDocPresignUrlForProfileThunk = createAsyncThunk<
  PresignUploadResponse,
  PresignUrlRequest
>("conversations/create_presign_upload", async (requestData, thunkAPI) => {
  try {
    const serializedFormData = await serializePresignUrlPyalod(requestData);
    const response =
      await accountSettingsAPI.createDocPresignUrlForProfile(
        serializedFormData,
      );

    return response.data;
  } catch (err: unknown) {
    return handleErrors(err as ApiError, thunkAPI);
  }
});

// export const AccessCalendarThunk = createAsyncThunk<
//   AccessCalendar,
//   AccessCalendarRequest
// >(
//   "accountSettingsSlice/access_calendar_thunk",
//   async (requestData, thunkAPI) => {
//     try {
//       const { data } = await accountSettingsAPI.accessCalendar(requestData);
//       return data;
//     } catch (err: unknown) {
//       return handleErrors(err as ApiError, thunkAPI);
//     }
//   },
// );

// export const DeleteCalendarThunk = createAsyncThunk(
//   "accountSettingsSlice/delete_calendar_thunk",
//   async (_, thunkAPI) => {
//     try {
//       const { data } = await accountSettingsAPI.deleteCalendar();
//       return data;
//     } catch (err: unknown) {
//       return handleErrors(err as ApiError, thunkAPI);
//     }
//   },
// );

// export const GetCalendarThunk = createAsyncThunk<ICalendar>(
//   "accountSettingsSlice/get_calendar_thunk",
//   async (_, thunkAPI) => {
//     try {
//       const { data } = await accountSettingsAPI.getCalendar();
//       return data;
//     } catch (err: unknown) {
//       return handleErrors(err as ApiError, thunkAPI);
//     }
//   },
// );

// export const UpdateCalendarThunk = createAsyncThunk<
//   void,
//   UpdateCalendarRequest
// >(
//   "accountSettingsSlice/update_calendar_thunk",
//   async (requestData, thunkAPI) => {
//     try {
//       const { data } = await accountSettingsAPI.updateCalendar(requestData);
//       return data;
//     } catch (err: unknown) {
//       return handleErrors(err as ApiError, thunkAPI);
//     }
//   },
// );

export const CreatePetThunk = createAsyncThunk<
  CreatePetResponse,
  CreatePetRequest
>(
  "accountSettingsSlice/create_pet_thunk",
  async (requestData: CreatePetRequest, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.createPet(requestData);
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI as GetThunkAPI);
    }
  },
);

export const GetPetsThunk = createAsyncThunk(
  "accountSettingsSlice/get_pets_thunk",
  async (_, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.getPets();
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const SendPhoneOtp = createAsyncThunk<SendOtpResponse, SendOtpRequest>(
  "profilePhone/sendOtp",
  async (payload, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.sendOtp(payload);

      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const VerifyPhoneOtp = createAsyncThunk<
  VerifyOtpResponse,
  VerifyOtpRequest
>("profilePhone/verifyOtp", async (payload, thunkAPI) => {
  try {
    const { data } = await accountSettingsAPI.verifyOtp(payload);

    return data;
  } catch (err: unknown) {
    return handleErrors(err as ApiError, thunkAPI);
  }
});

// ---------------- CONTACT PREFERENCES ----------------

export const UpdateContactPreference = createAsyncThunk<
  ContactPreferenceResponse,
  ContactPreferenceRequest
>(
  "profilePhone/updateContactPreference",

  async (payload, thunkAPI) => {
    try {
      const { data } =
        await accountSettingsAPI.updateContactPreference(payload);

      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const GetPetByIdThunk = createAsyncThunk<
  GetPetByIdResponse,
  GetPetByIdRequest
>(
  "accountSettingsSlice/get_pet_by_id_thunk",
  async (requestData: GetPetByIdRequest, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.getPetById(requestData.pet_id);
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const DeletePetThunk = createAsyncThunk<
  DeletePetResponse,
  DeletePetRequest
>(
  "accountSettingsSlice/delete_pet_thunk",
  async (requestData: DeletePetRequest, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.deletePet(requestData.pet_id);
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const UpdatePetThunk = createAsyncThunk<
  UpdatePetResponse,
  UpdatePetRequest
>(
  "accountSettingsSlice/update_pet_thunk",
  async (requestData: UpdatePetRequest, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.updatePet(requestData);
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const SearchAddressThunk = createAsyncThunk<Array<SearchAddress>, string>(
  "accountSettingsSlice/search_address_thunk",
  async (postalCode: string, thunkAPI) => {
    try {
      const { data } = await accountSettingsAPI.searchAddress(postalCode);
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const CreateProfileAddressThunk = createAsyncThunk<
  CreateProfileAddressResponse,
  CreateProfileAddressRequest
>(
  "profile/create_address_thunk",
  async (requestData: CreateProfileAddressRequest, thunkAPI) => {
    try {
      const { data } =
        await accountSettingsAPI.createProfileAddress(requestData);
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const UpdateNotificationPreferenceThunk = createAsyncThunk(
  "profile/updateNotificationPreference",

  async (payload: UpdateNotificationPreferenceRequest, thunkAPI) => {
    try {
      const response =
        await accountSettingsAPI.updateNotificationPreference(payload);
      return response.data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

const accountProfileThunk = {
  GetUserProfileThunk,
  ChangePasswordThunk,
  PatchSitterProfile,
  UpdateAboutMeThunk,
  GetFullUserProfileThunk,
  GetWalletBalanceThunk,
  CreateWithdrawThunk,
  // AccessCalendarThunk,
  // DeleteCalendarThunk,
  // GetCalendarThunk,
  // UpdateCalendarThunk,
  CreatePetThunk,
  GetPetsThunk,
  DeletePetThunk,
  UpdatePetThunk,
  SearchAddressThunk,
};
export default accountProfileThunk;
